const createBrowserHistory = require("history").createBrowserHistory;

export default createBrowserHistory();
